import { CharacteristicType } from '@/helper/Types'
import { Product } from '@/services/models/implementations/Product'
import { BufferTankCharacteristic } from '@/services/models/BufferTankCharacteristic'

export class Buffertank extends Product {

  public get chr(): BufferTankCharacteristic {
    return (
      this.getProductCharacteristic<BufferTankCharacteristic>(CharacteristicType.BUFFER_TANK) ||
      this.getProductCharacteristic<BufferTankCharacteristic>(CharacteristicType.COOLING_BUFFER_TANK)
    )
  }
}
